export default class MapboxMap {
  constructor({ main, opts }) {
    this._ = main;
    const {
      map,
      type,
      position,
      countries,
      zoom,
      marker,
      placeholder_place,
      placeholder_address,
      bbox,
      provinces,
      filter,
    } = opts;

    let geocoder;
    if (type === "place") {
      geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        countries: countries,
        mapboxgl: mapboxgl,
        marker: marker,
        types: type,
        placeholder: placeholder_place,
        bbox: bbox,
        zoom: zoom,
        filter: filter,
        // filter: geoCoderFilter,
      });
    } else if (type === "address") {
      geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        countries: countries,
        marker: marker,
        placeholder: placeholder_address,
        bbox: bbox,
        zoom: zoom,
        filter: filter,
      });
    }

    map.addControl(geocoder, position);
    geocoder.on("result", (ev) => {
      geocoder.clear();
      this.searchedLngLat = mapboxgl.LngLat.convert(ev.result.center);
      document.activeElement.blur();
    });

    // const provinces = [
    //   "Almería",
    //   "Cádiz",
    //   "Córdoba",
    //   "Granada",
    //   "Huelva",
    //   "Jaén",
    //   "Málaga",
    //   "Sevilla",
    // ];

    const searchIn = ["adress", "region"];
    function geoCoderFilter(item) {
      if (item.id.split(".").shift() !== "poi") {
        // https://docs.mapbox.com/mapbox-gl-js/example/mapbox-gl-geocoder-limit-region/
        if (
          provinces.find(function (province) {
            return item.place_name.indexOf(province) !== -1;
          }) !== undefined
        ) {
          return item.context
            .map(function (i) {
              if (searchIn.indexOf(i.id.split(".").shift()) != -1) {
                return i;
              }
            })
            .reduce(function (acc, cur) {
              return acc || cur;
            });
        }
      }
    }
  }
}
